import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex gap-x-1 items-center" }
const _hoisted_2 = { class: "text-sm font-medium leading-none text-neutral-600" }
const _hoisted_3 = { class: "mt-1.5" }

import { ref, onMounted } from "vue";
import tippy from "tippy.js";

export default /*@__PURE__*/_defineComponent({
  __name: 'FilterSection',
  props: {
    heading: {},
    tooltip: {}
  },
  setup(__props: any) {

const props = __props;

const button = ref(null);

onMounted(() => {
  if (props.tooltip) {
    tippy(button.value, {
      content: props.tooltip,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.heading), 1),
      (_ctx.tooltip)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            ref_key: "button",
            ref: button,
            class: "block"
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("span", {
              style: {"font-variation-settings":"'FILL' 1"},
              class: "text-2xl text-green-500 material-symbols-outlined"
            }, "info", -1)
          ]), 512))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})